export declare namespace AppTextTokenSections {
	interface Strong {
		color: string;
	}

	interface Emphasis {
		color: string;
	}

	interface Body {
		color: string;
	}

	interface Secondary {
		color: string;
	}

	interface Label {
		color: string;
	}

	interface Subdued {
		color: string;
	}

	interface Meta {
		color: string;
	}

	interface Muted {
		color: string;
	}

	interface Faint {
		color: string;
	}

	interface Default {
		color: string;
	}

	interface FieldLabel {
		color: string;
	}

	interface Ink {
		color: string;
	}

	interface Contrast {
		color: string;
	}

	interface Primary {
		color: string;
	}

	interface PrimarySoft {
		color: string;
	}

	interface PrimaryStrong {
		color: string;
	}

	interface Error {
		color: string;
	}

	interface Danger {
		color: string;
	}

	interface DangerSoft {
		color: string;
	}

	interface Success {
		color: string;
	}
}

export type AppTextTokens = {
	strong: AppTextTokenSections.Strong;
	emphasis: AppTextTokenSections.Emphasis;
	body: AppTextTokenSections.Body;
	secondary: AppTextTokenSections.Secondary;
	label: AppTextTokenSections.Label;
	subdued: AppTextTokenSections.Subdued;
	meta: AppTextTokenSections.Meta;
	muted: AppTextTokenSections.Muted;
	faint: AppTextTokenSections.Faint;
	default: AppTextTokenSections.Default;
	fieldLabel: AppTextTokenSections.FieldLabel;
	ink: AppTextTokenSections.Ink;
	contrast: AppTextTokenSections.Contrast;
	primary: AppTextTokenSections.Primary;
	primarySoft: AppTextTokenSections.PrimarySoft;
	primaryStrong: AppTextTokenSections.PrimaryStrong;
	error: AppTextTokenSections.Error;
	danger: AppTextTokenSections.Danger;
	dangerSoft: AppTextTokenSections.DangerSoft;
	success: AppTextTokenSections.Success;
};

export const strong: AppTextTokenSections.Strong = { color: '{surface.950}' };

export const emphasis: AppTextTokenSections.Emphasis = { color: '{surface.800}' };

export const body: AppTextTokenSections.Body = { color: '{surface.800}' };

export const secondary: AppTextTokenSections.Secondary = { color: '{surface.700}' };

export const label: AppTextTokenSections.Label = { color: '{surface.600}' };

export const subdued: AppTextTokenSections.Subdued = { color: '{surface.500}' };

export const meta: AppTextTokenSections.Meta = { color: '{surface.400}' };

export const muted: AppTextTokenSections.Muted = { color: '{text.muted.color}' };

export const faint: AppTextTokenSections.Faint = { color: '{surface.200}' };

export const defaultSection: AppTextTokenSections.Default = { color: '{text.color}' };

export const fieldLabel: AppTextTokenSections.FieldLabel = { color: '{neutral.950}' };

export const ink: AppTextTokenSections.Ink = { color: '{named.ink}' };

export const contrast: AppTextTokenSections.Contrast = { color: '{primary.contrast.color}' };

export const primary: AppTextTokenSections.Primary = { color: '{primary.color}' };

export const primarySoft: AppTextTokenSections.PrimarySoft = { color: '{primary.300}' };

export const primaryStrong: AppTextTokenSections.PrimaryStrong = { color: '{primary.600}' };

export const error: AppTextTokenSections.Error = { color: '{red.600}' };

export const danger: AppTextTokenSections.Danger = { color: '{red.500}' };

export const dangerSoft: AppTextTokenSections.DangerSoft = { color: '{red.400}' };

export const success: AppTextTokenSections.Success = { color: '{green.600}' };

/** Text colour roles for plain template text (`.app-text-*` in `css/appText`). */
export default {
	strong,
	emphasis,
	body,
	secondary,
	label,
	subdued,
	meta,
	muted,
	faint,
	default: defaultSection,
	fieldLabel,
	ink,
	contrast,
	primary,
	primarySoft,
	primaryStrong,
	error,
	danger,
	dangerSoft,
	success,
} satisfies AppTextTokens;
